(function () {
  'use strict';

  function boot() {
    var gallery = document.querySelector('[data-tubp-gallery]');
    if (!gallery || gallery.__tubpGalleryBooted) return;
    gallery.__tubpGalleryBooted = true;
    gallery.setAttribute('data-tubp-gallery-ready', 'true');

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-figure]'));
    var previous = gallery.querySelector('[data-tubp-gallery-prev]');
    var next = gallery.querySelector('[data-tubp-gallery-next]');
    var count = gallery.querySelector('[data-tubp-gallery-count]');
    var product = gallery.closest('[data-touch-up-bottle-product]') || document;
    var preview = product.querySelector('[data-tubp-gallery-preview]');
    var previewContent = preview && preview.querySelector('[data-tubp-gallery-preview-content]');
    var current = Math.max(0, slides.findIndex(function (slide) {
      return slide.getAttribute('data-gallery-selected') === 'true';
    }));
    var pointerStart = null;

    function renderPreview(index) {
      if (!preview || !previewContent || slides.length < 2) {
        if (preview) preview.hidden = true;
        return;
      }

      var sourceSlide = slides[index];
      if (!sourceSlide) return;
      var sourceImage = sourceSlide.querySelector('img');
      var sourceVideo = sourceSlide.querySelector('video');
      var mediaType = sourceSlide.getAttribute('data-media-type') || 'image';
      var previewImage = document.createElement('img');
      var previewSource = sourceImage && (sourceImage.getAttribute('src') || sourceImage.currentSrc);

      if (sourceVideo) previewSource = sourceVideo.getAttribute('poster') || previewSource;
      if (!previewSource) {
        preview.hidden = true;
        return;
      }

      previewImage.src = previewSource;
      previewImage.alt = '';
      previewImage.loading = 'eager';
      previewImage.setAttribute('aria-hidden', 'true');
      previewContent.replaceChildren(previewImage);
      preview.hidden = false;
      preview.classList.toggle('is-video', mediaType === 'custom_video');
      preview.setAttribute('data-preview-index', String(index));
      preview.setAttribute('aria-label', 'View product media ' + (index + 1) + ' of ' + slides.length);
    }

    function select(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var selected = slideIndex === current;
        slide.setAttribute('data-gallery-selected', String(selected));
        slide.setAttribute('aria-hidden', String(!selected));
        slide.setAttribute('tabindex', selected ? '0' : '-1');
        if (!selected) {
          var video = slide.querySelector('video');
          if (video) video.pause();
        }
      });
      if (count) count.textContent = (current + 1) + ' / ' + slides.length;
      renderPreview((current + 1) % slides.length);
    }

    if (previous) previous.addEventListener('click', function (event) {
      event.stopPropagation();
      select(current - 1);
    });
    if (next) next.addEventListener('click', function (event) {
      event.stopPropagation();
      select(current + 1);
    });
    if (preview) preview.addEventListener('click', function () { select(current + 1); });

    gallery.addEventListener('keydown', function (event) {
      if (event.target && event.target.closest('video')) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); select(current - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); select(current + 1); }
    });

    gallery.addEventListener('pointerdown', function (event) {
      if (event.target && event.target.closest('button, video')) return;
      pointerStart = { x: event.clientX, y: event.clientY };
    });
    gallery.addEventListener('pointerup', function (event) {
      if (!pointerStart) return;
      if (event.target && event.target.closest('button, video')) {
        pointerStart = null;
        return;
      }
      var x = event.clientX - pointerStart.x;
      var y = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(x) < 48 || Math.abs(x) < Math.abs(y)) return;
      select(x < 0 ? current + 1 : current - 1);
    });
    gallery.addEventListener('pointercancel', function () { pointerStart = null; });

    select(current);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
